import { Palette } from '@core/config/constants';

/** Nombre del grupo de personajes dentro del juego. */
export const GROUP_NAME = 'LUMINOVA';

/** Una integrante del grupo: datos y textura asociada. */
export interface CharacterDefinition {
  /** Identificador unico (se guarda en el perfil del jugador). */
  readonly key: string;
  /** Nombre visible. */
  readonly name: string;
  /** Color identitario del personaje. */
  readonly color: number;
  /** Clave de la textura cargada en Phaser. */
  readonly texture: string;
  /** Archivo dentro de public/assets. */
  readonly file: string;
}

export const CHARACTERS: readonly CharacterDefinition[] = [
  { key: 'maia', name: 'Maia', color: 0x7c4dff, texture: 'char-maia', file: 'char-maia.png' },
  { key: 'coral', name: 'Coral', color: 0xff5fa2, texture: 'char-coral', file: 'char-coral.png' },
  { key: 'sky', name: 'Sky', color: 0x4dd0e1, texture: 'char-sky', file: 'char-sky.png' },
  { key: 'sol', name: 'Sol', color: 0xffd54f, texture: 'char-sol', file: 'char-sol.png' },
  { key: 'mint', name: 'Mint', color: 0x2ecc71, texture: 'char-mint', file: 'char-mint.png' },
  { key: 'rouge', name: 'Rouge', color: 0xff2d8e, texture: 'char-rouge', file: 'char-rouge.png' },
];

/** Textura de la imagen grupal (banner del menu). */
export const GROUP_LINEUP_TEXTURE = 'group-lineup';
export const GROUP_LINEUP_FILE = 'characters-lineup.png';

/** Color de marco por defecto para tarjetas de personaje. */
export const CHARACTER_CARD_BORDER = Palette.highlight;

/** Devuelve la definicion de un personaje por su key (o undefined si no existe). */
export function findCharacter(key: string): CharacterDefinition | undefined {
  return CHARACTERS.find((character) => character.key === key);
}
